import { useState } from "react";
import { BASE_URL } from "../../../config/api";
import toast from "react-hot-toast";
import axios from "axios";

export default function RejectWarranty({ warrantyId, isRejected, onSuccess }) {

  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const rejectReasons = [
    "Invalid IMEI",
    "Duplicate Warranty",
    "Outside Coverage",
    "Expired Warranty",
    "Other",
  ];

  const handleSubmit = async () => {

    if (!reason) {

      toast.error(
        "Please select a reject reason"
      );

      return;
    }

    if (
      reason === "Other" &&
      !note.trim()
    ) {

      toast.error(
        "Please enter note for 'Other' reason"
      );

      return;
    }

    setLoading(true);

    try {

      const response =
        await axios.post(
          `${BASE_URL}warranty/update-warranty-status/${warrantyId}`,
          {
            is_approved: 2,
            reject_remark: reason,
            note: note,
          },
          {
            headers: {
              Accept:
                "application/json",

              "Content-Type":
                "application/json",
            },
          }
        );

      const data =
        response.data;

      toast.success(
        "Warranty rejected successfully ❌"
      );

      onSuccess?.();

    } catch (err) {

      toast.error(
        err?.response?.data
          ?.message ||
        err?.message ||
        "Failed to reject warranty"
      );

    } finally {

      setLoading(false);

    }
  };


 return (
  <div className="space-y-4 max-w-md">

    {/* ALREADY REJECTED MESSAGE */}
    {isRejected && (
      <div className="p-3 rounded-lg bg-red-50 text-red-700 text-sm border border-red-200">
        This warranty has already been rejected.
      </div>
    )}

    {/* REASON */}
    <div>
      <label className="text-sm font-medium text-slate-600">
        Reject Reason
      </label>
      <select
        value={reason}
        disabled={isRejected}
        onChange={(e) => setReason(e.target.value)}
        className="mt-1 w-full px-3 py-2 border rounded-lg text-sm disabled:bg-slate-100"
      >
        <option value="">Select reason</option>
        {rejectReasons.map((r) => (
          <option key={r} value={r}>
            {r}
          </option>
        ))}
      </select>
    </div>

    {/* NOTE */}

      <div>
        <label className="text-sm font-medium text-slate-600">
          Note
        </label>
        <textarea
          value={note}
          disabled={isRejected}
          onChange={(e) => setNote(e.target.value)}
          rows={3}
          className="mt-1 w-full px-3 py-2 border rounded-lg text-sm disabled:bg-slate-100"
          placeholder="Enter rejection note..."
        />
      </div>

    {/* BUTTON */}
    <button
      onClick={handleSubmit}
      disabled={isRejected || loading}
      className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {isRejected ? "Already Rejected" : loading ? "Rejecting..." : "Reject Warranty"}
    </button>
  </div>
);

}
